"use client";

import { useState, useEffect } from 'react';
import Image from 'next/image';

const ScreenLoader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if document is already loaded
    if (document.readyState === 'complete') {
      // Add 2-second delay before hiding loader
      const timer = setTimeout(() => {
        setIsLoading(false);
      },1000 );
      return () => clearTimeout(timer);
    } else {
      // Set up event listener for when the page is fully loaded
      const handleLoad = () => {
        // Add 2-second delay after page load
        const timer = setTimeout(() => {
          setIsLoading(false);
        }, 2000);
        return () => clearTimeout(timer);
      };
      window.addEventListener('load', handleLoad);

      // Cleanup event listener
      return () => {
        window.removeEventListener('load', handleLoad);
      };
    }
  }, []);

  return (
    <>
      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-r from-[#00063A] via-[#425fae] to-[#00063A] transition-opacity duration-500 ease-in-out">
          <Image
            src="/ex-logo-preview.png"
            alt="Loading"
            width={100}
            height={100}
            className="object-contain animate-[beat_1.2s_ease-in-out_infinite]"
            priority
          />
        </div>
      )}
    </>
  );
};

export default ScreenLoader;